<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newInterScheme">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newInterScheme">Create New Permitted Scheme per Intermediary</v-toolbar-title>
          <v-toolbar-title v-else>Edit Permitted Scheme per Intermediary</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <!--
              <v-flex xs12>
                <v-autocomplete :items="accounts" v-model="interSchemeForm.inter" item-text="label" item-value="value" :label="interSchemeLabel.inter"
                  :error-messages="errors.collect('interSchemeForm.inter')" :disabled ="newInterScheme === false" data-vv-name="interSchemeForm.inter" :data-vv-as="interSchemeLabel.inter"
                  v-validate="'required|param|max:8'" clearable>
                </v-autocomplete>
              </v-flex>
              -->
              <v-flex xs12>
                <v-text-field
                  v-model="interSchemeForm.inter"
                  :label="interSchemeLabel.inter"
                  :error-messages="errors.collect('inter')"
                  data-vv-name="inter"
                  :data-vv-as="interSchemeLabel.inter"
                  v-validate="isValidInter"
                  :disabled="newInterScheme === false"
                  @blur="doGetDesc(interSchemeForm.inter)"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="showInterHelpList = true" v-text="'mdi-magnify'" :disabled="newInterScheme === false"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-autocomplete
                  :items="scheme"
                  v-model="interSchemeForm.scheme"
                  item-text="label"
                  item-value="value"
                  :label="interSchemeLabel.scheme"
                  :error-messages="errors.collect('interSchemeForm.scheme')"
                  :disabled="newInterScheme === false"
                  data-vv-name="interSchemeForm.scheme"
                  :data-vv-as="interSchemeLabel.scheme"
                  v-validate="'required|param|max:4'"
                  clearable
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs2>
                <v-checkbox color="primary" :label="interSchemeLabel.defaultSchemeAE" v-model="interSchemeForm.defaultSchemeAE"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  v-model="interSchemeForm.effDate"
                  :label="interSchemeLabel.effDate"
                  :data-vv-as="interSchemeLabel.effDate"
                  data-vv-name="interSchemeForm.effDate"
                  :error-messages="errors.collect('interSchemeForm.effDate')"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  v-model="interSchemeForm.expDate"
                  :label="interSchemeLabel.expDate"
                  :data-vv-as="interSchemeLabel.expDate"
                  data-vv-name="interSchemeForm.expDate"
                  :error-messages="errors.collect('interSchemeForm.expDate')"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="interSchemeForm.createdBy"
                  :label="interSchemeLabel.createdBy"
                  disabled
                  :error-messages="errors.collect('interSchemeForm.createdBy')"
                  data-vv-name="interSchemeForm.createdBy"
                  :data-vv-as="interSchemeLabel.createdBy"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  v-model="interSchemeForm.createdDate"
                  :label="interSchemeLabel.createdDate"
                  disabled
                  :data-vv-as="interSchemeLabel.createdDate"
                  data-vv-name="interSchemeForm.createdDate"
                  :error-messages="errors.collect('interSchemeForm.createdDate')"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-if="!newInterScheme">
                <v-text-field
                  v-model="interSchemeForm.modifiedBy"
                  :label="interSchemeLabel.modifiedBy"
                  disabled
                  :error-messages="errors.collect('interSchemeForm.modifiedBy')"
                  data-vv-name="interSchemeForm.modifiedBy"
                  :data-vv-as="interSchemeLabel.modifiedBy"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="!newInterScheme">
                <cal-picker
                  v-model="interSchemeForm.modifiedDate"
                  :label="interSchemeLabel.modifiedDate"
                  disabled
                  :data-vv-as="interSchemeLabel.modifiedDate"
                  data-vv-name="interSchemeForm.modifiedDate"
                  :error-messages="errors.collect('interSchemeForm.modifiedDate')"
                ></cal-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="white--text error" @click.prevent="doBack">
            Cancel
            <v-icon right>mdi-exit-to-app</v-icon>
          </v-btn>
          <v-btn color="primary" dark @click="doSave" :loading="submitting">
            Save Permitted Scheme
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>

    <v-dialog v-model="showInterHelpList" width="1280px">
      <intermediary-help-list @close="showInterHelpList = false" @assign-intermediary-data="assignIntermediary"></intermediary-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      accounts: [],
      scheme: [],
      submitting: false,
      showInterHelpList: false,
      interSchemeLabel: {
        inter: 'Intermediary',
        scheme: 'Scheme',
        defaultSchemeAE: 'Default Scheme',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      interSchemeForm: {
        inter: null,
        scheme: null,
        defaultSchemeAE: false,
        effDate: null,
        expDate: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      validInter: false
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('interScheme'))
    this.$store.commit('INTERSCHEME_COMMIT_KEY', jsonData)

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })

    this.$validator.extend('inter', {
      getMessage(field, args) {
        return 'Invalid Data'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var stat = args[0]
        if (stat === true) {
          return true
        } else {
          return false
        }
      }
    })
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('accounts')
      this.getCommonDataList('scheme')
      if (this.newInterScheme) {
        this.interSchemeForm.effDate = new Date()
        this.interSchemeForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.interSchemeForm.createdDate = new Date()
      } else {
        // this.interSchemeForm.inter = this.interSchemeId.inter
        this.doGetDesc(this.interSchemeId.inter)
        this.interSchemeForm.scheme = this.interSchemeId.scheme
        if (this.interSchemeId.defaultSchemeAE === 'Yes') {
          this.interSchemeForm.defaultSchemeAE = true
        }
        this.interSchemeForm.effDate = this.interSchemeId.effDate
        this.interSchemeForm.expDate = this.interSchemeId.expDate
        this.interSchemeForm.createdBy = this.interSchemeId.createdBy
        this.interSchemeForm.createdDate = this.interSchemeId.createdDate
        this.interSchemeForm.modifiedBy = this.interSchemeId.modifiedBy
        this.interSchemeForm.modifiedDate = this.interSchemeId.modifiedDate
      }
    },
    doBack() {
      this.$router.push({ name: 'interScheme' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newInterScheme) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createInterScheme
      if (apiURI) {
        let messageFilters = clone(this.interSchemeForm)
        const spltInter = this.interSchemeForm.inter.split('-')

        if (spltInter !== '' && spltInter !== null) {
          messageFilters.inter = spltInter[0]
        }
        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        this.$http
          .post(apiURI, messageFilters)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'interScheme' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateInterScheme
      if (apiURI) {
        let messageFilters = clone(this.interSchemeForm)
        const spltInter = this.interSchemeForm.inter.split('-')

        if (spltInter !== '' && spltInter !== null) {
          messageFilters.inter = spltInter[0].trim()
        }

        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        this.$http
          .put(apiURI, messageFilters)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'interScheme' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    assignIntermediary(data) {
      this.interSchemeForm.inter = data.inter + ' - ' + data.name
      this.showInterHelpList = false
      this.validInter = false
    },
    doGetDesc(event) {
      const data = event.split('-')
      if (data !== '') {
        const fliterData = {
          inter: data[0]
        }
        this.getDataDesc('intermediary', fliterData)
      }
    },
    doAssignDesc(data) {
      if (data.id !== undefined) {
        this.interSchemeForm.inter = data.id + ' - ' + data.name
        this.validInter = false
      } else {
        this.validInter = true
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.interScheme.menu
    },
    interSchemeId() {
      return this.$store.state.interScheme.interScheme.interSchemeId
    },
    newInterScheme() {
      return this.interSchemeId.inter === null
    },
    expDateValidation() {
      if (this.interSchemeForm.expDate !== '' && this.interSchemeForm.expDate !== null) {
        return 'entry|valExpiry:' + this.interSchemeForm.effDate
      } else {
        return ''
      }
    },
    isValidInter() {
      if (this.validInter && this.interSchemeForm.inter !== '') {
        return 'required|inter:' + this.validInter
      } else {
        return 'required'
      }
    }
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    IntermediaryHelpList
  }
}
</script>

<style>
</style>
